import { Card } from 'nhsuk-react-components';
import { useNavigate, useParams } from 'react-router-dom';
import { RuleType, ruleTypeMap } from 'schemas/IterationRule.schema.ts';
import { AllowedTemplateKeys } from 'schemas/CampaignTemplates.schema.ts';
import RuleLibraryHeader from 'components/RuleLibraryHeader/index.tsx';
import useProtectRoute from 'hooks/useProtectRoute.ts';
import useCampaign from 'hooks/useCampaign.ts';
import useFetchTemplateForCampaign from 'queries/fetch/fetchTemplateForCampaign.ts';
import RuleLibrarySelect from 'components/forms/RuleLibrary/RuleLibrarySelect';
import RulesExplanationText from 'components/RulesExplanationText';

interface IRulesLibraryProps {
    ruleType: RuleType
  }

const RULE_TYPE_DISPLAY_KEY: Record<RuleType, AllowedTemplateKeys> = {
  F: 'IterationDetails.IterationRules.filters.input.display',
  S: 'IterationDetails.IterationRules.suppressions.input.display',
  R: 'IterationDetails.IterationRules.routing.input.display',
};

export default function RuleLibrary({ ruleType }: IRulesLibraryProps) {
  const { teamId, campaignId, iterationId } = useParams();
  const navigate = useNavigate();
  useProtectRoute();
  const { campaign } = useCampaign();
  const { data: campaignTemplate } = useFetchTemplateForCampaign({
    teamId: teamId!,
    campaignId: campaignId!,
    isEnabled: Boolean(campaign.CampaignConfig.Template),
  });

  if (campaignTemplate?.[RULE_TYPE_DISPLAY_KEY[ruleType]] === 'hidden') {
    navigate(`/${teamId}/campaign/${campaignId}/iteration/${iterationId}/summary`);
    return null;
  }

  return (
    <>
      <RuleLibraryHeader ruleType={`${ruleTypeMap[ruleType]} rules`} />
      <Card className="nhsuk-u-margin-bottom-0">
        <RulesExplanationText ruleType={ruleType} />
      </Card>
      <RuleLibrarySelect ruleType={ruleType} />
    </>
  );
}
